import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  stockDetail: null,
  stockLoading: false,
};

const stockSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {
    _setStockDetail: (state, action) => {
      state.stockDetail = action.payload;
    },
    _setStockLoading: (state, action) => {
      state.stockLoading = action.payload;
    },
  },
});

export const { _setStockDetail, _setStockLoading } = stockSlice.actions;

export default stockSlice.reducer;
